import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import MyLoader from '../../common/loader.component';
import { OutletContextParams } from './delivery-orders-screen';
import {
  CleanConversation,
  CleanTransportation,
} from '../../../export-types/cleaned-types';
import { useConversationNewMessages } from '../../../api/conversation';
import { TransportationTabItem } from './transportation-tab-item';
import { useTransportations } from '../../../api/transportations';
import { ExpandButton } from '../../row';

export const TransportationsPackagedTab = () => {
  const {
    debouncedInternalId,
    attention,
    linked,
    expanded,
    collapsed,
    onChangeCollapsed,
    selectSupplier,
    direction,
  } = useOutletContext<OutletContextParams>();
  const [collapsedStorage, setCollapsedStorage] = useState<string[]>([]);

  const { data, error, isLoading, mutate } = useTransportations({
    linked,
    attention,
    status: ['packagedCombined'],
    name: debouncedInternalId || undefined,
    supplierId: selectSupplier || undefined,
    direction,
    sort: 'createdAt',
  });

  const newMessageHandler = React.useCallback(
    (updatedConversation: CleanConversation) => {
      if (
        data?.items.some((transportation) =>
          transportation.lines.some(
            (line) =>
              line.deliveryOrder.id === updatedConversation.deliveryOrder?.id,
          ),
        )
      ) {
        mutate();
      }
    },
    [data, mutate],
  );
  useConversationNewMessages(newMessageHandler, 'deliveries');

  const onToggle = (transportation: CleanTransportation) => {
    if (collapsed.includes(transportation.id)) {
      const newCollapsed = [...collapsed];
      newCollapsed.splice(newCollapsed.indexOf(transportation.id), 1);
      onChangeCollapsed(newCollapsed);
    } else {
      onChangeCollapsed([...collapsed, transportation.id]);
    }
  };

  const onToggleStorage = (storage: string) => {
    if (collapsedStorage.includes(storage)) {
      const newCollapsed = [...collapsedStorage];
      newCollapsed.splice(newCollapsed.indexOf(storage), 1);
      setCollapsedStorage(newCollapsed);
    } else {
      setCollapsedStorage([...collapsedStorage, storage]);
    }
  };

  if (isLoading) {
    return (
      <>
        <div className="pb-4">
          <MyLoader />
        </div>
      </>
    );
  }

  if (error || !data) {
    return (
      <>
        <div className="pb-4">Неизвестная ошибка</div>
      </>
    );
  }

  return (
    <div className="pb-4">
      {data.items.map((transportation) => {
        const warehouse =
          transportation.lines[0]?.deliveryOrder?.purchaseOrders?.[0]
            ?.supplierWarehouse;
        const storageLocation = transportation.packing?.storageLocation;

        return (
          <div key={transportation.id} className="border-bottom mb-3">
            <div className="d-flex flex-row gap-2 fs-21">
              {warehouse?.location?.name || 'Склад не указан'}:{' '}
              {storageLocation ? `${storageLocation}` : 'место не указано'}
              <div className="mleft-auto">
                <ExpandButton
                  onToggle={() => onToggleStorage(transportation.id)}
                  collapsed={collapsedStorage.includes(transportation.id)}
                />
              </div>
            </div>

            {!collapsedStorage.includes(transportation.id) && (
              <TransportationTabItem
                data={transportation}
                onCollapsedChange={() => onToggle(transportation)}
                collapsed={
                  (!expanded && collapsed.includes(transportation.id)) ||
                  (expanded && !collapsed.includes(transportation.id))
                }
                status="assembly"
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
